import React, { useEffect, useState } from "react";
import './Slider.scss';

type SliderProps = {
    className?: string,
    label: string,
    value: number,
    onChange: (value: number) => void,
};

function Slider(props: SliderProps) {
    const [value, setValue] = useState<number>(props.value);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = +e.target.value;
        props.onChange(newValue);
        setValue(newValue);
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div className={`slider ${props.className ?? ''}`}>
            <span className="slider-label">{props.label} : {Math.round(value)}%</span>
            <input type="range" onChange={handleChange} value={value}/>
        </div>
    );
}

export default Slider;
